__turbopack_context__.v({
  "link": "ExternalLink-module-scss-module__4EoN_q__link",
});
